import { render, staticRenderFns } from "./ReleaseHistory.vue?vue&type=template&id=c101e346&scoped=true&"
import script from "./ReleaseHistory.vue?vue&type=script&lang=js&"
export * from "./ReleaseHistory.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseHistory.vue?vue&type=style&index=0&id=c101e346&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c101e346",
  null
  
)

export default component.exports